import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ScheduleTable from "../ScheduleTable/component";
import {
    fetchSportsSchedule,
    update_sports_schedule_filter,
    update_sports_schedule_filter_bar,
} from "../../../../actions/Schedule/actions";
import { SCHEDULE_IS_EMPTY_DESCRIPTION } from "./constants";
import { SectionHeading } from "../../../Heading/component";
import FilterBar from "../FilterBar/component";
import { useParams } from "react-router-dom";
import { DEFAULT_TIMEZONE } from "../../../../utils/dateTime/constants";
import { getUserTimeZone } from "../../../../utils/dateTime/library";
import { useFilterBarParams } from "./hooks";
import { isServer } from "../../../../utils/environmentDetection/library";
import { updatePageDescription } from "./utils";

const getEmptyScheduleHeading = (heading) => {
    return heading ? (
        <heading.type
            {...heading.props}
            description={SCHEDULE_IS_EMPTY_DESCRIPTION}
        />
    ) : (
        <SectionHeading description={SCHEDULE_IS_EMPTY_DESCRIPTION} />
    );
};

const useFilter = (filter) => {
    const { sport, platform } = useParams();
    const types = filter?.types || (sport && [sport]);
    return {
        types,
        platform: platform === "streaming" ? "web" : platform,
        ...filter,
    };
};

const MainSchedule = ({ filter, heading, filterBar }) => {
    const dispatch = useDispatch();
    const key = useSelector((state) => state?.app?.section);
    const filterBarParams = {
        ...filterBar,
        ...useFilterBarParams(key),
    };
    const filteredScheduleList = useSelector((state) => {
        return state.schedule[key]?.filteredScheduleList || [];
    });
    const caption = useSelector((state) => {
        return state.schedule[key]?.caption || "";
    });
    const zone = useSelector((state) => {
        return state.schedule[key]?.zone || DEFAULT_TIMEZONE;
    });
    const currentFilter = useFilter(filter);
    const { platform } = currentFilter;
    const page = useSelector((state) => state?.page);

    // fetch server-side
    const isServerSide = isServer();
    if (isServerSide) {
        dispatch(update_sports_schedule_filter_bar(key, filterBarParams));
        dispatch(
            update_sports_schedule_filter(key, currentFilter, DEFAULT_TIMEZONE)
        );
        dispatch(fetchSportsSchedule(key, isServerSide));
    }

    useEffect(() => {
        dispatch(update_sports_schedule_filter_bar(key, filterBarParams));
    }, [filterBarParams.type]);

    // fetch client-side
    useEffect(() => {
        dispatch(
            update_sports_schedule_filter(key, currentFilter, getUserTimeZone())
        );
        dispatch(fetchSportsSchedule(key));
        updatePageDescription(dispatch, page);
    }, [key]);

    return (
        <div className={"mainSchedule"}>
            {filterBar && <FilterBar stateKey={key} />}
            {filteredScheduleList.length !== 0 ? (
                <>
                    {heading}
                    <ScheduleTable
                        tableData={filteredScheduleList}
                        shouldLink={platform === "web" ? true : false}
                        caption={caption}
                        showNb={platform === "tv" ? true : false}
                        zone={zone}
                    />
                </>
            ) : (
                <>{getEmptyScheduleHeading(heading)}</>
            )}
        </div>
    );
};

export default MainSchedule;
